import { CloseIcon } from "vega-icons";

import { ActionaryModal } from "@vega-core/components/Modals/ActionaryModal/ActionaryModal";
import { m } from "@vega-core/paraglide/messages";

import { type ProspectWithFormData } from "../stores/prospectsStore";

type SelectedProspectsModalProps = {
  open: boolean;
  onClose: () => void;
  selectedProspects: ProspectWithFormData[];
  onRemove: (limitedPartnerId: string) => void;
};

export const SelectedProspectsModal = ({
  open,
  onClose,
  selectedProspects,
  onRemove,
}: SelectedProspectsModalProps) => (
  <ActionaryModal
    dataTestId="selected-prospects-modal"
    open={open}
    setOpen={onClose}
    title={m.coInvestments_findProspectsFromSalesforce_selectedProspects()}
  >
    <ul className="flex flex-col gap-6 min-w-80">
      {selectedProspects.map((prospect) => (
        <li
          className="flex items-center justify-between gap-4"
          data-testid={`selected-prospect-${prospect.limitedPartnerId}`}
          key={prospect.limitedPartnerId}
        >
          <div className="flex flex-col items-start gap-1 text-start">
            <span className="body-base-medium">
              {prospect.limitedPartnerName}
            </span>
            <span className="body-base-medium text-text/secondary">
              {prospect.limitedPartnerRegion || "—"}
            </span>
          </div>
          <button
            aria-label={m.coInvestments_prospects_remove_button()}
            className="flex-shrink-0 hover:opacity-70"
            data-testid={`remove-selected-prospect-${prospect.limitedPartnerId}`}
            onClick={() => onRemove(prospect.limitedPartnerId)}
            type="button"
          >
            <CloseIcon className="size-4" />
          </button>
        </li>
      ))}
    </ul>
  </ActionaryModal>
);
